import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ThemesService from "../api/themes";
import { getUrlVars } from "../utils/systemInfo";
import TemplateAddEdit from "../common/Layout/templatePages/templateAddEdit";
import { setThemeLinking } from "../store/themeLinkingSlice";

const initialState = {
  operation_profile_id: "",
  theme_profile_id: "",
  theme_profile_link_id: "",
  status: "active",
};

const breadcrumbs = [
  { id: 0, name: "Home", href: "./" },
  { id: 1, name: "Themes", href: "themesApi" },
  { id: 2, name: "Add/Edit Theme Linking", href: "addEditThemeLinking" },
];
function AddEditThemeApi() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const themeLinking = useSelector(({ themeLinking }) => themeLinking);
  const organziation = useSelector(({ organziation }) => organziation);
  const themeLinkingId = String(getUrlVars()["id"]);

  useEffect(() => {
    if (!getUrlVars()["id"]) {
      dispatch(setThemeLinking(initialState));
    }
    if (themeLinking.theme_profile_link_id === "" && getUrlVars()["id"]) {
      const apiKey =
        organziation?.api_key_list?.[0]?.key ?? localStorage.getItem("apiKey");
      ThemesService.getThemeProfileLink({
        theme_profile_link_id: themeLinkingId,
        apiKey,
      })
        .then((jsonCurrent) => {
          if (jsonCurrent?.theme_profile_link?.length) {
            const themeObject = jsonCurrent?.theme_profile_link[0];
            dispatch(
              setThemeLinking({
                operation_profile_id: themeObject.operation_profile_id,
                theme_profile_id: themeObject.theme_profile_id,
                theme_profile_link_id: themeObject.theme_profile_link_id,
                status: themeObject.status,
              })
            );
          }
        })
        .catch((errorr) => {
          if (process.env.NODE_ENV === "development")
            console.log("getUserTypePermissionserrorr", errorr);
        });
    }

    // return () => {
    //   dispatch(setTag(initialState));
    // };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [themeLinking]);

  function handleSave({
    operation_profile_id,
    theme_profile_id,
    theme_profile_link_id,
    status,
    api_key_current,
  }) {
    ThemesService.SetThemeProfileLink({
      operation_profile_id,
      theme_profile_id,
      theme_profile_link_id,
      status,
      api_key_current,
    }).then((json) => {
      if (json.success === true && json.count > 0) {
        navigate("/themesApi");
      }
    });
  }
  return (
    <TemplateAddEdit
      breadcrumbs={breadcrumbs}
      title="AddEditThemeOrganizationLink"
      gridCol={2}
      item={themeLinking}
      dataToShow={[
        {
          key: "operation_profile_id",
          label: "OrganizationId",
          type: "text",
          isRequired: true,
        },
        {
          key: "theme_profile_id",
          label: "ThemeId",
          type: "text",
          isRequired: true,
        },
        { key: "status", type: "text" },
      ]}
      onSaveClick={(item) =>
        handleSave({
          ...item,
          api_key_current: organziation?.api_key_list?.[0]?.key,
        })
      }
    />
  );
}

export default AddEditThemeApi;
